import { unreachable } from 'module/helpers/unreachable';
import { FieldType } from 'module/types/filter-field/field/field';
//import { AssigneeFieldValue } from './assignee';
import { BooleanFieldValue } from './boolean';
import { DateFieldValue } from './date';
import { MultiLineTextFieldValue } from './multi-line-text';
import { MultiSelectFieldValue } from './multi-select';
//import { MultiUserFieldValue } from './multi-user';
import { NumberFieldValue } from './number';
import { SingleSelectFieldValue } from './single-select';
import { SingleUserFieldValue } from './single-user';
import { TextFieldValue } from './text';

export const getFieldValue = (type: FieldType) => {
  switch (type) {
    case FieldType.Boolean:
      return BooleanFieldValue;
    case FieldType.Date:
      return DateFieldValue;
    case FieldType.Text:
      return TextFieldValue;
    case FieldType.MultiLineText:
      return MultiLineTextFieldValue;
    case FieldType.Number:
      return NumberFieldValue;
    // Below types - single select, multi select, single user, multi user and assignee are not reachable because of the editor check
    case FieldType.SingleSelect:
      return SingleSelectFieldValue;
    case FieldType.MultiSelect:
      return MultiSelectFieldValue;
    case FieldType.SingleUser:
      return SingleUserFieldValue;
    case FieldType.MultiUser:
      return undefined;
    case FieldType.Assignee:
      return undefined;
    case FieldType.Note:
      return undefined;
    case FieldType.Estimate:
      return unreachable(type as never); // estimate is not an actual custom field type
    default:
      return unreachable(type);
  }
};

export const isSelect = (type: FieldType) => {
  switch (type) {
    case FieldType.Boolean:
    case FieldType.Date:
    case FieldType.Text:
    case FieldType.MultiLineText:
    case FieldType.Number:
    case FieldType.Estimate:
    case FieldType.Note:
      return false;
    case FieldType.SingleSelect:
    case FieldType.MultiSelect:
    case FieldType.SingleUser:
    case FieldType.MultiUser:
    case FieldType.Assignee:
      return true;
    default:
      return unreachable(type);
  }
};
